import { useMemo } from 'react'
import { Link } from '~/components'
import { Image } from '~/components/Image'
import Tag from '~/components/Tag'
import TagImage from '~/components/TagImage'
import { filterProductTags, getImageSrc } from '~/helpers'
import { Product } from '~/types'
import { ProductDashboardStoreAvailabilityStatus } from '../ProductDashboardShippingMethods/StoreAvailabilitySection'
import styles from './ProductDashboardHighlights.module.scss'

export interface ProductDashboardHighlightsProps {
  product: Product
  storeAvailabilityStatus?: ProductDashboardStoreAvailabilityStatus
}

export const ProductDashboardHighlights = ({
  product,
  storeAvailabilityStatus,
}: ProductDashboardHighlightsProps) => {
  const { brandImage, tags } = product
  const { isEndlessAisleFromSupplier } = storeAvailabilityStatus || {}

  const filteredTags = useMemo(() => {
    return filterProductTags(tags ?? [], !!isEndlessAisleFromSupplier)
  }, [tags, isEndlessAisleFromSupplier])

  if (!brandImage?.src && filteredTags.length === 0) {
    return null
  }

  return (
    <div className={styles.root}>
      {filteredTags.length > 0 && (
        <div className={styles.tags}>
          {filteredTags.map((tag, index) => {
            return (
              <Tag
                variant='primary'
                key={index}
                backgroundColor={tag.backgroundColor}
                color={tag.color}>
                <span className={styles.tagText}>{tag.desc}</span>
              </Tag>
            )
          })}
        </div>
      )}

      {brandImage?.src && brandImage?.href && (
        <Link
          href={brandImage.href ?? ''}
          className={styles.brand}
          target='_blank'
          rel='noopener noreferrer'>
          <Image
            src={getImageSrc(brandImage.src, '100')}
            addSrcSet={false}
            alt={brandImage.altText}
            className={styles.brandImage}
          />
        </Link>
      )}
    </div>
  )
}
